export const URL_LOGIN = "/v1/user/form/login";
export const URL_GET_USER_INFO = "/v1/gocheckin/business/site/info";
export const URL_FORGOT_PASSWORD = "/v1/user/form/forgot-password";
export const URL_CHECK_OTP = "/v1/user/form/check-otp";
export const URL_RESET_PASSWORD = "/v1/user/form/reset-password";
export const URL_GET_CONFIG = "/v1/settings/checkout/get-config";
export const URL_GET_DOMAIN = "/site/get-info"
export const URL_REGISTER_TOKEN = "/v1/gocheckin/notification/form/register-token";
export const URL_REMOVE_TOKEN = "/v1/gocheckin/notification/form/remove-token"
export const URL_GET_USER_SIGNIN_INFO = "/v1/user/site/info";
